import { useContext, useEffect, useState } from "react";
import { AuthService } from "../../services/AuthService";
import { useLocation } from "react-router-dom";

const Article = () => {

    const location = useLocation();

  const getProductDetails = async (product) => {
    let res = await AuthService.getProductDetails(product?.barcode);
    console.log("getProductDetails", res);
    if (res && res?.barcode) {

    }
  }

    useEffect(()=>{
        if (location.state?.product) {
            getProductDetails(location.state?.product)
        }
    }, []) 
    return <p>Articlee</p>
}

export default Article